module.exports = __webpack_public_path__ + "img/empty_result.6d9aeb70.png";